import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ArticleType } from "../../../../../__generated__/gql/graphql";
import Button from "../../../../../ui/Button/Button";
import Label from "../../../../../ui/Label/Label";
import styles from "./PatternArticleType.module.scss";
import Select from "../../../../../ui/Select/Select";
import articleTypeOptions from "./article-type-options";

const schema = z.object({
  type: z.nativeEnum(ArticleType).optional(),
});

export type PatternArticleTypeData = z.infer<typeof schema>;

function PatternArticleType({
  onSubmit,
  defaultValue,
}: {
  onSubmit: (data: PatternArticleTypeData) => void;
  defaultValue?: PatternArticleTypeData;
}) {
  const { handleSubmit, control } = useForm<PatternArticleTypeData>({
    resolver: zodResolver(schema),
    defaultValues: defaultValue,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Label label="Select an Article Type">
        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <Select
              data={Object.values(ArticleType).map((value) => ({
                value,
                label: articleTypeOptions[value],
              }))}
              onBlur={field.onBlur}
              onChange={(value) => field.onChange(value)}
              ref={field.ref}
              value={field.value}
            />
          )}
        />
      </Label>
      <Button className={styles.submitButton} type="submit" variant="primary">
        Continue
      </Button>
    </form>
  );
}

export default PatternArticleType;
